import { RequestsInstance } from 'api';
import { AxiosRequestConfig } from 'axios';
import { BetMatchesDTO } from 'features/betMatch/interface';

const BetMatchApiWrapper = (requests: RequestsInstance) => {
	return {
		betMatches: (config?: AxiosRequestConfig) => {
			return requests.get<BetMatchesDTO>(`cms/betmatches`, config).then((res) => res.data.data);
		},
	};
};

export default BetMatchApiWrapper;
